/* IZECOmfort · Black Friday: detalles en la ficha, la barra fija y el formulario. Se configura en la sección «IZC · Black Friday». */
(function(){
'use strict';
var d=document,h=d.documentElement,C=window.IZC_BF||{};
if(!h.classList.contains('izc-bf'))return;
function $(s,r){return (r||d).querySelector(s);}
function $$(s,r){return [].slice.call((r||d).querySelectorAll(s));}
function el(tag,cls,txt){var e=d.createElement(tag);if(cls)e.className=cls;if(txt!=null)e.textContent=txt;return e;}
var L=C.label||'Black Friday';
var end=null;
if(C.end&&/^\d{4}-\d{2}-\d{2}$/.test(C.end)){var p=C.end.split('-');end=new Date(+p[0],+p[1]-1,+p[2],23,59,59);}
if(end&&new Date()>end){h.classList.remove('izc-bf');return;}
h.style.setProperty('--izc-bf-badge',JSON.stringify(L+' · '));

function pad(n){return (n<10?'0':'')+n;}
function left(){
  if(!end||!(C.days>0))return null;
  var ms=end-new Date();if(ms<=0||ms>C.days*864e5)return null;
  var s=Math.floor(ms/1000),dd=Math.floor(s/86400),hh=Math.floor(s%86400/3600),mm=Math.floor(s%3600/60),ss=s%60;
  return 'Termina en '+(dd?dd+' d ':'')+pad(hh)+':'+pad(mm)+':'+pad(ss);
}
function decorate(){
  /* etiqueta sobre la foto */
  $$('.izc-flags').forEach(function(f){if(!$('.izc-flag-bf',f))f.insertBefore(el('span','izc-flag izc-flag-bf',L),f.firstChild);});
  /* aviso junto al precio */
  $$('.izc-price').forEach(function(pr){
    var prev=pr.previousElementSibling;if(prev&&prev.classList.contains('izc-bf-tag'))return;
    var t=el('div','izc-bf-tag');t.appendChild(el('b','',L));
    var s=el('span','',left()||C.price_text||'');s.setAttribute('data-izc-bf-left','');t.appendChild(s);
    pr.parentNode.insertBefore(t,pr);
  });
  /* título de los packs */
  if(C.packs)$$('.izc-bundles').forEach(function(b){var l=b.previousElementSibling;if(l&&l.classList.contains('izc-label')&&l.textContent!==C.packs)l.textContent=C.packs;});
  /* barra fija del móvil */
  $$('.izc-sticky-p').forEach(function(sp){if(!$('.izc-bf-mini',sp))sp.insertBefore(el('span','izc-bf-mini',L),sp.firstChild);});
  /* formulario de pedido */
  if(C.form)$$('#easysell-modal .izc-es-k').forEach(function(k){if(k.textContent!==C.form)k.textContent=C.form;});
}
function tick(){var t=left();$$('[data-izc-bf-left]').forEach(function(s){var v=t||C.price_text||'';if(s.textContent!==v)s.textContent=v;});}
decorate();
if(left()!==null)setInterval(tick,1000);
if('MutationObserver' in window){var q=0;new MutationObserver(function(){if(q)return;q=requestAnimationFrame(function(){q=0;decorate();});}).observe(d.body,{childList:true,subtree:true});}
})();
